<template>
    <div v-if='value && value.header && value.scheme' class='w-100 mb-1 mt-1'>
        <template v-if='editable'>
            <div class='d-flex flex-row align-items-center'>
                <template v-if='showheader'>
                <select v-model='value.header' class='form-control form-control-sm w-auto mr-1'>
                    <option>{{$t('translations.problem')}}</option>
                    <option>{{$t('translations.history')}}</option>
                    <option>{{$t('translations.examination')}}</option>
                    <option>{{$t('translations.family_history')}}</option>
                    <option>{{$t('translations.social')}}</option>
                    <option>{{$t('translations.comment')}}</option>
                    <option>{{$t('translations.procedure')}}</option>
                </select>
                </template>
                <select v-model='value.scheme' class='form-control form-control-sm w-auto mr-1' v-on:change='value.term = ""; value.code = ""; value.description_id = ""; $refs.codeauto.clear()'>
                    <option>SNOMED</option>
                    <option>READ2</option>
                </select>
                <autocomplete2 ref='codeauto' class="form-control flex-grow-1 mr-1"
                        :source="$root.apiBase + '/code/' + this.codingapi + '_' + (this.value.scheme == 'SNOMED' ? 'snomed' : 'read') + '?search='"
                        results-property="data"
                        results-value="id"
                        @selected='setDisplayValue'
                        @clear='setDisplayValue'
                        @close='setDisplayValue'
                        :results-display="formattedCodeDisplay"
                        :request-headers="authHeaders"
                        :showNoResults="false"
                        :placeholder="this.$t('translations.search_min_3_characters')"
                        >
                    </autocomplete2>
                <input :placeholder="this.$t('translations.code')" size='10' class='form-control form-control-sm w-auto mr-1' :type='showcodes ? "text" : "hidden"' v-model='value.code'>
                <input :placeholder="this.$t('translations.description_id')" size='10' class='form-control form-control-sm w-auto mr-1' :type='showcodes ? "text" : "hidden"' v-model='value.description_id'>
                <input :placeholder="this.$t('translations.term')"  class='form-control form-control-sm flex-grow-1 mr-1' type='hidden' v-model='value.term'>
                <input :placeholder="this.$t('translations.value')" size='8' class='form-control form-control-sm w-auto mr-1' :type='showvalue ? "text" : "hidden"' v-model='value.value'>
                <input :placeholder="this.$t('translations.unit')" size='8' class='form-control form-control-sm w-auto mr-1' type='text' v-model='value.units'>
            </div>
            <div v-if='showdescription' class='d-flex flex-row align-items-center mt-1'>
                <textarea @focus="show_characters_left = true" @blur="show_characters_left = false" rows='1' v-autosize="value.descriptive_text" :placeholder="this.$t('translations.description')" style='width:100%' class='form-control form-control-sm mr-1' type='text' v-model='value.descriptive_text' />
                
                <!-- v-on:keyup='update()'  -->
                <!-- <div class='align-self-center'>
                <button 
                    class='btn btn-light btn-sm btn-clear' 
                    v-on:click.prevent="clear">x</button>
                </div> -->
            </div>
            <div class='d-flex flex-row align-items-center'>
                <p v-if='show_characters_left' class='h6 text-nowrap chars-left mb-0 mt-2 mr-1 ml-1'  aria-live="polite" >{{ charactersLeft }}</p>
            </div>
        </template>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
    props: {
        value: {
        },
        editable: {
            default: true,
        },
        showcodes: {
            default: false,
        },
        showheader: {
            default: true,
        },
        showvalue: {
            default: true,
        },
        showdescription: {
            default: true,
        }
    },
    data() {
        return {
            resetCounter: 0,
            show_characters_left: false,
            selectedObject: {},
            codingapi: "rds"
        };
    },
    computed: {
        charactersLeft() {
            if(typeof this.value.descriptive_text === 'string') {
                var char = this.value.descriptive_text.length;
                var limit = 1024;

                if(char > limit) {
                    this.value.descriptive_text = this.value.descriptive_text.substr(0, limit);
                    char = this.value.descriptive_text.length;
                }
                return (limit - char) + " " + this.$t('translations.characters_remaining');
            }
            return "";
        },
        authHeaders () {
            return {
                'Authorization': axios.defaults.headers.common['Authorization'],
                'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
            }
        },
    },
    watch: {
        
    },
    mounted() {
        //console.info(this.value);
        if(!this.value.scheme) {
            Vue.set(this.value, 'scheme', 'SNOMED');
            Vue.set(this.value, 'header', 'History');
            Vue.set(this.value, 'code', '');
            Vue.set(this.value, 'term', '');
            Vue.set(this.value, 'units', '');
            Vue.set(this.value, 'value', '');
            Vue.set(this.value, 'descriptive_text', '');
        }
        if(this.value.term) {
            this.$refs.codeauto.display = this.value.term;
        }
    },
    methods: {
        clear() {
            this.value.scheme = "SNOMED";
            this.value.header = "History";
            this.value.code = "";
            this.value.description_id = "";
            this.value.term = "";
            this.value.units = "";
            this.value.value = "";
            this.value.descriptive_text = "";
        },
        reset() {
            // So annoying. If you enter a partial date, then the code has no way to know that that
            // is being displayed in the UI. So we force new components to refresh.
            this.resetCounter++;
        },
        formattedCodeDisplay (result) {
            // var bannerComponent = Vue.component("patient-banner");
            // var banner = new bannerComponent({propsData: { user: result }});
            // //var banner = new this.$options.components["patient-banner"]({propsData: { user: result }});
            // //console.info(banner);
            // banner.$root.lookup = this.$root.lookup;
            // console.info(banner);
            // banner.$mount();
            if(result) {
                if(result.display) {
                    return "" 
                        + result.display 
                        + (result.snomedEdition == "UK" ? " <span class='badge badge-primary'>UK</span>" : "") 
                        + ((result.QOFCategories && result.QOFCategories.length) ? " <span class='badge badge-warning'>QOF</span>" : "") 
                        + " [" + result.coding[0].code + "]";
                }
                else if(result.term60) {
                    return "" 
                        + result.term60 
                        + (result.qof ? " <span class='badge badge-warning'>QOF</span>" : "") 
                        + " [" + result.termid + "]";
                }
                else {
                    return "" 
                        + result.term 
                        + (result.typeid == "900000000000013009" ? " <span class='badge badge-info'>Synonym</span>" : "") 
                        + (result.typeid == "900000000000550004" ? " <span class='badge badge-info'>Textual</span>" : "") 
                        + (result.typeid == "900000000000003001" ? " <span class='badge badge-success'>FSN</span>" : "") 
                        + (result.gb ? " <span class='badge badge-primary'>GB</span>" : "") 
                        + (result.qof ? " <span class='badge badge-warning'>QOF</span>" : "") 
                        + " [" + result.conceptid + "]";
                }
            }
            return '';
        },
        setDisplayValue(auto) {
            if(auto && auto.selectedObject) {
                if(auto.selectedObject.display) {
                    this.value.code = auto.selectedObject.coding[0].code; 
                    this.value.description_id = auto.selectedObject.coding[0].descriptionId; 
                    this.value.term = auto.selectedObject.display;
                }
                else if(auto.selectedObject.term60) {
                    this.value.code = auto.selectedObject.termid; 
                    this.value.term = auto.selectedObject.term60;
                }
                else {
                    this.value.code = auto.selectedObject.conceptid; 
                    this.value.term = auto.selectedObject.term;
                }
                this.selectedObject = auto.selectedObject;
            }
            Vue.nextTick(() => {
                this.$refs.codeauto.display = this.value.term;
            });
        },
        clearDisplayValue() {
            value.code = null; 
            value.description_id = null; 
            value.term = null; 
            search = null;
        }
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>